import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  constructor() {}

  GetSession(): any {
    if (typeof document !== 'undefined') {
      const name = `${environment.apiLocations.cookieName}=`;
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(name)) {
          const encodedUserStr = cookie.substring(name.length);
          const decodedUserStr = decodeURIComponent(encodedUserStr);
          try {
            return JSON.parse(decodedUserStr);
          } catch (error) {
            console.error('Error parsing session cookie:', error);
            return null;
          }
        }
      }
    }

    return null;
  }

  SetSession(user: any): void {
    const userStr = JSON.stringify(user);
    const encodedUserStr = encodeURIComponent(userStr); 

    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + 24 * 60 * 60 * 1000);

    document.cookie = `${
      environment.apiLocations.cookieName
    }=${encodedUserStr};expires=${expirationDate.toUTCString()};path=/;secure;domain=${
      environment.apiLocations.cookieDomain
    };secure;SameSite=Strict`;
  }

  ClearSession(): void {
    if (typeof document !== 'undefined') {
      document.cookie = `${environment.apiLocations.cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;secure;SameSite=Lax`;
    }
  }

  TerminateSession(): void {
    this.ClearSession();
  }
}
